import axis from './axis'

function percent(nameOrOption) {
  const option = axis(nameOrOption)

  return {
    axisLabel: {
      formatter(value) {
        return `${value.toLocaleString()}%`
      }
    },
    ...option
  }
}

export default percent



// WEBPACK FOOTER //
// ./src/components/Chart/axies/percent.js